import { PatternFormat } from "react-number-format";

const PhoneNumberFormat = (props) => {
  const { inputRef, onChange, ...other } = props;
  return (
    <PatternFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      format="(###) ###-####"
      mask="_"
    />
  );
};

export default PhoneNumberFormat;
